module.exports = __webpack_public_path__ + "img/ico-introduction-2.b34a45b4.svg";